export enum PageType {
    STANDARD = 'STANDARD',
    TOKENIZATION = 'TOKENIZATION',
    VERIFICATION = 'VERIFICATION',
    PAYBYLINK = 'PAYBYLINK',
    PAYBYLINK_VERIFICATION = 'PAYBYLINK_VERIFICATION',
    EMBEDDED_WIDGET = 'EMBEDDED_WIDGET'
}
